<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12">
  <app-select-form-field
      formControlName="createdById"
      [label]="'case.fields.createdById.label' | translate"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="createdByUsers"
      [bindValue]="'id'"
      [bindLabel]="'fullName'"
      [viewMode]="viewMode"
      (onSearchEvent)="searchUsers('search', $event.term, 'createdByUsers', $event.page, $event.take)"
      (onScrollEvent)="searchUsers('scroll', $event.term, 'createdByUsers', $event.page, $event.take)"
  ></app-select-form-field>
  </div>
  <div class="col-12">
  <app-select-form-field
      formControlName="ticketOwnerId"
      [label]="'case.fields.ticketOwnerId.label' | translate"
      [helpText]="'case.fields.ticketOwnerId.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="ticketOwnerUsers"
      [bindValue]="'id'"
      [bindLabel]="'fullName'"
      [viewMode]="viewMode"
      [externalSearch]="true"
      (onSearchEvent)="searchUsers('search', $event.term, 'ticketOwnerUsers', $event.page, $event.take)"
      (onScrollEvent)="searchUsers('scroll', $event.term, 'ticketOwnerUsers', $event.page, $event.take)"
      (onSelectEvent)="changeTicketOwner($event)"
  ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-select-form-field
      formControlName="internalCaseContactId"
      [label]="'case.fields.internalCaseContactId.label' | translate"
      [helpText]="'case.fields.internalCaseContactId.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="caseContactUsers"
      [bindValue]="'id'"
      [bindLabel]="'fullName'"
      [viewMode]="viewMode"
      (onChangeEvent)="onSelectinternalCaseContact($event)"
      [externalSearch]="true"
      (onSearchEvent)="searchUsers('search', $event.term, 'caseContactUsers', $event.page, $event.take)"
      (onScrollEvent)="searchUsers('scroll', $event.term, 'caseContactUsers', $event.page, $event.take)"
    ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-select-form-field
      formControlName="stcResourceId"
      [label]="'case.fields.stcResourceId.label' | translate"
      [helpText]="'case.fields.stcResourceId.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="stcUsers"
      [bindValue]="'id'"
      [bindLabel]="'fullName'"
      [viewMode]="viewMode"
      [externalSearch]="true"
      (onSearchEvent)="searchUsers('search', $event.term, 'stcUsers', $event.page, $event.take)"
      (onScrollEvent)="searchUsers('scroll', $event.term, 'stcUsers', $event.page, $event.take)"
    ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-select-form-field
      formControlName="pcResourceId"
      [label]="'case.fields.pcResourceId.label' | translate"
      [helpText]="'case.fields.pcResourceId.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="pcUsers"
      [bindValue]="'id'"
      [bindLabel]="'fullName'"
      [viewMode]="viewMode"
      [externalSearch]="true"
      (onSearchEvent)="searchUsers('search', $event.term, 'pcUsers', $event.page, $event.take)"
      (onScrollEvent)="searchUsers('scroll', $event.term, 'pcUsers', $event.page, $event.take)"
    ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-select-form-field
      formControlName="appsResourceId"
      [label]="'case.fields.appsResourceId.label' | translate"
      [helpText]="'case.fields.appsResourceId.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="appsUsers"
      [bindValue]="'id'"
      [bindLabel]="'fullName'"
      [viewMode]="viewMode"
      [externalSearch]="true"
      (onSearchEvent)="searchUsers('search', $event.term, 'appsUsers', $event.page, $event.take)"
      (onScrollEvent)="searchUsers('scroll', $event.term, 'appsUsers', $event.page, $event.take)"
    ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-select-form-field
      formControlName="epartResourceId"
      [label]="'case.fields.epartResourceId.label' | translate"
      [helpText]="'case.fields.epartResourceId.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [items]="epartResource"
      [bindValue]="'id'"
      [bindLabel]="'fullName'"
      [viewMode]="viewMode"
      [externalSearch]="true"
      (onSearchEvent)="searchUsers('search', $event.term, 'epartResource', $event.page, $event.take)"
      (onScrollEvent)="searchUsers('scroll', $event.term, 'epartResource', $event.page, $event.take)"
    ></app-select-form-field>
  </div>
</div>
